'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = analytics;

var _immutable = require('immutable');

var _AnalyticsActionTypes = require('../actionTypes/AnalyticsActionTypes');

var initialState = new _immutable.Map({
  isNewUser: null,
  isNewPortal: null
});

function analytics() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  switch (action.type) {
    case _AnalyticsActionTypes.ANALYTICS_USER_NEW:
      return state.set('isNewUser', true);

    case _AnalyticsActionTypes.ANALYTICS_USER_EXISTING:
      return state.set('isNewUser', false);

    case _AnalyticsActionTypes.ANALYTICS_PORTAL_NEW:
      return state.set('isNewPortal', true);

    case _AnalyticsActionTypes.ANALYTICS_PORTAL_EXISTING:
      return state.set('isNewUser', false).set('isNewPortal', false);

    default:
      return state;
  }
}
module.exports = exports['default'];